<template>

  <div>
    <!--商家列表-->
    <Supply v-if="activeName == 'supply'"></Supply>
       <!--商家分类-->
       <Category v-if="activeName == 'category'"></Category>
    <Staff  v-if="activeName == 'staff'"></Staff>

 <Real_estate  v-if="activeName == 'real_estate'"></Real_estate>


    <!--商家等级-->
    <Grade v-if="activeName == 'grade'"></Grade>
    <!--商家设置-->
    <Setting v-if="activeName == 'setting'"></Setting>
  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Supply from './supply/index';
import Setting from './setting/getSetting.vue';
import Grade from './grade/index';
import Category from './category/index';
import Staff from './../../plus/staff/index/index';

import Real_estate from './../../plus/real_estate/index/index';


export default {
  components: {
    Supply,
    Setting,
    Grade,
    Category,
    Staff,
    Real_estate
  },
  data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'supply',
      /*切换数组*/
      sourceList: [
        {
          key: 'supply',
          value: '商家/物业列表',
          path:'/plus/supply/supply/index'
        },
   {
          key: 'real_estate',
          value: '房产',
            path:'/plus/real_estate/index/index'
        },
        
           {
          key: 'staff',
          value: '商家会员/管家',
          path:'/plus/staff/index'
        },
        {
          key: 'category',
          value: '行业分类',
          path:'/plus/supply/category/index'
        },
        {
          key: 'grade',
          value: '等级',
          path:'/plus/supply/grade/index'
        },
        {
          key: 'setting',
          value: '设置',
          path:'/plus/supply/setting/getSetting'
        },
       
      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {

    this.init();

  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'supply',list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'supply'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/supply/index.vue